import type { ForumPost } from '~/data/forumPosts'
import type { components } from '~/types/napis'

export type ForumUserRoles = Exclude<
  components['schemas']['UserTypeChoice'],
  'COMPANY_STAFF' | 'JOB_COURSE_ADMIN'
>
// export type ForumUserRoles =
//   | 'STUDENT'
//   | 'TEST_USER'
//   | 'JOB_ADMIN'
//   | 'COURSE_ADMIN'
//   | 'TALENT_ADMIN'
//   | 'INSTRUCTOR'

export type ForumCategoryTypes = components['schemas']['PostCategoryOption']
// export type ForumCategoryTypes = 'GENERAL' | 'SKILL' | 'CAREER' | 'CLASSROOM'

export type ForumTagSlugNames =
  | 'dev-humour'
  | 'networking'
  | 'success-stories'
  | 'resources'
  | 'tech-news'
  | 'python'
  | 'javascript'
  | 'sql'
  | 'tensor-flow'
  | 'express'
  | 'react-js'
  | 'node-js'
  | 'career-advice'
  | 'freelancing'
  | 'resume'
  | 'interview'
  | 'remote-work'
  | 'work-life-balance'

export const forumTagSlugs = [
  'dev-humour',
  'networking',
  'success-stories',
  'resources',
  'tech-news',
  'python',
  'javascript',
  'sql',
  'tensor-flow',
  'express',
  'react-js',
  'node-js',
  'career-advice',
  'freelancing',
  'resume',
  'interview',
  'remote-work',
  'work-life-balance'
]

export type ForumCategory = {
  id_slug: string
  category_name: components['schemas']['PostCategoryOption']
  tag_count: number
  description?: string
}

export type ForumAuthor = {
  id_slug: string
  profile_image?: string
  first_name: string
  last_name: string
  user_roles: ForumUserRoles[]
  email?: string
}

export type ForumTag = {
  id_slug: string
  slug_name: ForumTagSlugNames | string
  name: string
  description: string
  category: ForumCategory
  followers_count: number
  is_user_follow?: boolean
  posts?: ForumPost[]
}

export type ForumComment = {
  id_slug: string
  created_date: string
  modified_date: string
  post?: ForumPost // missing
  parent_comment?: ForumComment
  replies?: ForumComment[] // missing
  author: ForumAuthor
  description: string
  is_answer: boolean
  vote_value: number
  reply_count: number
  upvote_count: number
  downvote_count: number
  total_vote_count: number
  is_bookmarked?: boolean
  is_user_upvote?: boolean // missing
  is_user_downvote?: boolean // missing
  is_hidden: boolean
}

export type ForumReport = {
  id_slug: string
  created_date: string
  status: 'pending' | 'approved' | 'rejected'
  reason: string
  author: ForumAuthor
  post?: ForumPost
  comment?: ForumComment
}

export type ForumBookMarkPostListResponse = {
  data: ForumPost[]
  count: number
  num_pages: number
}

export type ForumBookMarkCommentListResponse = {
  data: ForumPost[]
  count: number
  num_pages: number
}

export const tempForumCategory: ForumCategory[] = [
  {
    id_slug: 'category-gen',
    category_name: 'GENERAL',
    tag_count: 5,
    description: `News, updates, or random tech-related topics`
  },
  {
    id_slug: 'category-ski',
    category_name: 'SKILL',
    tag_count: 7,
    description: `Your hub for mastering essential tech skills`
  },
  {
    id_slug: 'category-car',
    category_name: 'CAREER',
    tag_count: 6,
    description: `Ask for advice on navigating your tech career`
  },
  {
    id_slug: 'category-cls',
    category_name: 'CLASSROOM',
    tag_count: 1
  }
]

export const tempForumTags: ForumTag[] = [
  {
    id_slug: 'tag-0',
    slug_name: 'dev-humour',
    name: 'Dev Humour',
    description: '',
    category: tempForumCategory[0], // general
    followers_count: 100,
    is_user_follow: true
  },
  {
    id_slug: 'tag-0-0',
    slug_name: 'networking',
    name: 'Networking',
    description: '',
    category: tempForumCategory[0], // general
    followers_count: 100,
    is_user_follow: true
  },
  {
    id_slug: 'tag-0-1',
    slug_name: 'success-stories',
    name: 'Success stories',
    description: '',
    category: tempForumCategory[0], // general
    followers_count: 100,
    is_user_follow: false
  },
  {
    id_slug: 'tag-0-2',
    slug_name: 'resources',
    name: 'Resources',
    description: '',
    category: tempForumCategory[0], // general
    followers_count: 100,
    is_user_follow: true
  },
  {
    id_slug: 'tag-0-3',
    slug_name: 'tech-news',
    name: 'Tech news',
    description: '',
    category: tempForumCategory[0], // general
    followers_count: 100,
    is_user_follow: false
  },
  {
    id_slug: 'tag-1',
    slug_name: 'python',
    name: 'Python',
    description: '',
    category: tempForumCategory[1], // skill
    followers_count: 100,
    is_user_follow: true
  },
  {
    id_slug: 'tag-1-0',
    slug_name: 'javascript',
    name: 'Javascript',
    description: '',
    category: tempForumCategory[1], // skill
    followers_count: 100,
    is_user_follow: false
  },
  {
    id_slug: 'tag-1-5',
    slug_name: 'sql',
    name: 'SQL',
    description: '',
    category: tempForumCategory[1], // skill
    followers_count: 100,
    is_user_follow: false
  },
  {
    id_slug: 'tag-1-4',
    slug_name: 'tensor-flow',
    name: 'TensorFlow',
    description: '',
    category: tempForumCategory[1], // skill
    followers_count: 100,
    is_user_follow: true
  },
  {
    id_slug: 'tag-1-2',
    slug_name: 'express',
    name: 'Express',
    description: '',
    category: tempForumCategory[1], // skill
    followers_count: 100,
    is_user_follow: false
  },
  {
    id_slug: 'tag-1-3',
    slug_name: 'react-js',
    name: 'React.js',
    description: '',
    category: tempForumCategory[1], // skill
    followers_count: 100,
    is_user_follow: true
  },
  {
    id_slug: 'tag-1-1',
    slug_name: 'node-js',
    name: 'Node.js',
    description: '',
    category: tempForumCategory[1], // skill
    followers_count: 100,
    is_user_follow: false
  },
  {
    id_slug: 'tag-2',
    slug_name: 'career-advice',
    name: 'Career Advice',
    description: '',
    category: tempForumCategory[2], // career
    followers_count: 100,
    is_user_follow: false
  },
  {
    id_slug: 'tag-2-0',
    slug_name: 'freelancing',
    name: 'Freelancing',
    description: '',
    category: tempForumCategory[2], // career
    followers_count: 100,
    is_user_follow: false
  },
  {
    id_slug: 'tag-2-1',
    slug_name: 'resume',
    name: 'Resume',
    description: '',
    category: tempForumCategory[2], // career
    followers_count: 100,
    is_user_follow: true
  },
  {
    id_slug: 'tag-2-2',
    slug_name: 'interview',
    name: 'Interview',
    description: '',
    category: tempForumCategory[2], // career
    followers_count: 100,
    is_user_follow: false
  },
  {
    id_slug: 'tag-2-3',
    slug_name: 'remote-work',
    name: 'Remote work',
    description: '',
    category: tempForumCategory[2], // career
    followers_count: 100,
    is_user_follow: false
  },
  {
    id_slug: 'tag-2-4',
    slug_name: 'work-life-balance',
    name: 'Work-life balance',
    description: '',
    category: tempForumCategory[2], // career
    followers_count: 100,
    is_user_follow: true
  },
  {
    id_slug: 'tag-3',
    slug_name: 'kydp-cada-sept-24',
    name: 'KYDP CADA September 2024 Intake',
    description: '',
    category: tempForumCategory[3], // classroom
    followers_count: 100,
    is_user_follow: false
  },
  {
    id_slug: 'tag-3-0',
    slug_name: 'kydp-caba-sept-24',
    name: 'KYDP CABA September 2024 Intake',
    description: '',
    category: tempForumCategory[3], // classroom
    followers_count: 100,
    is_user_follow: false
  },
  {
    id_slug: 'tag-3-2',
    slug_name: 'google-certificate-career-24',
    name: 'Google Certificate Career 2024',
    description: '',
    category: tempForumCategory[3], // classroom
    followers_count: 100,
    is_user_follow: false
  },
  {
    id_slug: 'tag-3-1',
    slug_name: 'google-certificate-career-25',
    name: 'Google Certificate Career 2025',
    description: '',
    category: tempForumCategory[3], // classroom
    followers_count: 100,
    is_user_follow: false
  },
  {
    id_slug: 'tag-3-4',
    slug_name: 'kydp-fintech-sept-24',
    name: 'KYDP FinTech September 2024 Intake',
    description: '',
    category: tempForumCategory[3], // classroom
    followers_count: 100,
    is_user_follow: false
  },
  {
    id_slug: 'tag-3-5',
    slug_name: 'kydp-cabed-sept-24',
    name: 'KYDP CABED September 2024 Intake',
    description: '',
    category: tempForumCategory[3], // classroom
    followers_count: 100,
    is_user_follow: true
  },
  {
    id_slug: 'tag-3-6',
    slug_name: 'google-certificate-career-24',
    name: 'Google Certificate Career 2024',
    description: '',
    category: tempForumCategory[3], // classroom
    followers_count: 100,
    is_user_follow: true
  },
  {
    id_slug: 'tag-3-7',
    slug_name: 'kydp-fcda-sept-24',
    name: 'KYDP FCDA September 2024 Intake',
    description: '',
    category: tempForumCategory[3], // classroom
    followers_count: 100,
    is_user_follow: false
  }
]

export const tempForumUsers: ForumAuthor[] = [
  {
    id_slug: 'm_wr2YkQTTqmUqoAXJgR1g',
    profile_image: '/images/landing/landing-page/community/landing-community-42.png',
    first_name: 'Minji',
    last_name: 'Kim',
    user_roles: ['STUDENT'],
    email: 'newjeans-minji@email.com'
  },
  {
    id_slug: 'user-1',
    profile_image: '/images/landing/landing-page/community/landing-community-6.png',
    first_name: 'Hanni',
    last_name: 'Kim',
    user_roles: ['COURSE_ADMIN', 'STUDENT'],
    email: 'newjeans-hanni@email.com'
  },
  {
    id_slug: 'user-2',
    profile_image: '/images/landing/landing-page/community/landing-community-12.png',
    first_name: 'Jennie',
    last_name: 'Kim',
    user_roles: ['INSTRUCTOR'],
    email: 'blackpink-jennie@email.com'
  },
  {
    id_slug: 'user-3',
    profile_image: '/images/landing/landing-page/community/landing-community-15.png',
    first_name: 'Jisoo',
    last_name: 'Kim',
    user_roles: ['JOB_ADMIN', 'TALENT_ADMIN'],
    email: 'blackpink-jisoo@email.com'
  },
  {
    id_slug: 'user-4',
    profile_image: '/images/landing/landing-page/community/landing-community-21.png',
    first_name: 'Rose',
    last_name: 'Kim',
    user_roles: ['STUDENT'],
    email: 'blackpink-rose@email.com'
  },
  {
    id_slug: 'user-5',
    first_name: 'Lisa',
    last_name: 'Kim',
    user_roles: ['COURSE_ADMIN', 'STUDENT'],
    email: 'blackpink-lisa@email.com'
  },
  {
    id_slug: 'user-2-1',
    profile_image: '/images/landing/landing-page/community/landing-community-11.png',
    first_name: 'Jojo',
    last_name: 'Kim',
    user_roles: ['INSTRUCTOR'],
    email: 'blackpink-jojo@email.com'
  },
  {
    id_slug: 'user-3-1',
    profile_image: '/images/landing/landing-page/community/landing-community-14.png',
    first_name: 'John',
    last_name: 'Kim',
    user_roles: ['JOB_ADMIN', 'TALENT_ADMIN'],
    email: 'blackpink-john@email.com'
  },
  {
    id_slug: 'user-4-1',
    profile_image: '/images/landing/landing-page/community/landing-community-19.png',
    first_name: 'Lala',
    last_name: 'Kim',
    user_roles: ['STUDENT'],
    email: 'blackpink-lala@email.com'
  },
  {
    id_slug: 'user-5-1',
    first_name: 'Wendy',
    last_name: 'Kim',
    user_roles: ['COURSE_ADMIN', 'STUDENT'],
    email: 'blackpink-wendy@email.com'
  },
  {
    id_slug: 'user-2-2',
    profile_image: '/images/landing/landing-page/community/landing-community-32.png',
    first_name: 'Jamie',
    last_name: 'Kim',
    user_roles: ['INSTRUCTOR'],
    email: 'blackpink-jamie@email.com'
  },
  {
    id_slug: 'user-3-2',
    profile_image: '/images/landing/landing-page/community/landing-community-9.png',
    first_name: 'Bob',
    last_name: 'Kim',
    user_roles: ['JOB_ADMIN', 'TALENT_ADMIN'],
    email: 'blackpink-bob@email.com'
  },
  {
    id_slug: 'user-4-2',
    profile_image: '/images/landing/landing-page/community/landing-community-23.png',
    first_name: 'Taylor',
    last_name: 'Swift',
    user_roles: ['STUDENT'],
    email: 'taylor-swift@email.com'
  },
  {
    id_slug: 'user-5-2',
    first_name: 'Aimee',
    last_name: 'Kim',
    user_roles: ['COURSE_ADMIN', 'STUDENT'],
    email: 'blackpink-aimee@email.com'
  }
]

const dummyPost: ForumPost = {
  id_slug: 'post-0',
  tags: [tempForumTags[0], tempForumTags[10]],
  author: tempForumUsers[0],
  title: 'Why is JavaScript asynchronous by default?',
  description:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
  created_date: '2024-12-01T13:19:53.648Z',
  modified_date: '2024-12-01T13:19:53.648Z',
  groups: [],
  vote_value: 1,
  answer_count: 0,
  comment_count: 0,
  upvote_count: 10,
  downvote_count: 2,
  total_vote_count: 8,
  is_hidden: false,
  is_announcement: false,
  is_pinned: false,
  is_user_downvote: false,
  is_user_follow: false,
  is_user_upvote: true,
  is_bookmarked: true,
  is_resolved: false,
  categories: [tempForumCategory[0], tempForumCategory[1]],
  image: '/images/landing/landing-page/hero/bg-1.png'
}

export const tempForumReplies: ForumComment[] = [
  {
    id_slug: 'reply-0',
    created_date: '2024-12-08T13:19:53.648Z',
    modified_date: '2024-12-08T13:19:53.648Z',
    author: tempForumUsers[0],
    description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco.
      <br/>
      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco`,
    is_answer: false,
    vote_value: 0,
    reply_count: 0,
    upvote_count: 21,
    downvote_count: 10,
    total_vote_count: 11,
    is_user_downvote: false,
    is_user_upvote: false,
    is_hidden: true
  },
  {
    id_slug: 'reply-1',
    created_date: '2024-12-08T13:19:53.648Z',
    modified_date: '2024-12-08T13:19:53.648Z',
    author: tempForumUsers[2],
    description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco.
    <br/>
    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco`,
    is_answer: false,
    vote_value: -1,
    reply_count: 0,
    upvote_count: 21,
    downvote_count: 10,
    total_vote_count: 11,
    is_user_downvote: true,
    is_user_upvote: false,
    is_hidden: false
  },
  {
    id_slug: 'reply-2',
    created_date: '2024-12-08T13:19:53.648Z',
    modified_date: '2024-12-08T13:19:53.648Z',
    author: tempForumUsers[3],
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.',
    is_answer: true,
    vote_value: 1,
    reply_count: 0,
    upvote_count: 21,
    downvote_count: 10,
    total_vote_count: 11,
    is_user_downvote: false,
    is_user_upvote: true,
    is_hidden: false
  },
  {
    id_slug: 'reply-3',
    created_date: '2024-12-08T13:19:53.648Z',
    modified_date: '2024-12-08T13:19:53.648Z',
    author: tempForumUsers[1],
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut.',
    is_answer: false,
    vote_value: 0,
    reply_count: 0,
    upvote_count: 21,
    downvote_count: 10,
    total_vote_count: 11,
    is_user_downvote: false,
    is_user_upvote: false,
    is_hidden: false
  },
  {
    id_slug: 'reply-4',
    created_date: '2024-12-08T13:19:53.648Z',
    modified_date: '2024-12-08T13:19:53.648Z',
    author: tempForumUsers[2],
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco',
    is_answer: false,
    vote_value: -1,
    reply_count: 0,
    upvote_count: 21,
    downvote_count: 10,
    total_vote_count: 11,
    is_user_downvote: true,
    is_user_upvote: false,
    is_hidden: false
  },
  {
    id_slug: 'reply-5',
    created_date: '2024-12-08T13:19:53.648Z',
    modified_date: '2024-12-08T13:19:53.648Z',
    author: tempForumUsers[3],
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco',
    is_answer: false,
    vote_value: 1,
    reply_count: 0,
    upvote_count: 21,
    downvote_count: 10,
    total_vote_count: 11,
    is_user_downvote: false,
    is_user_upvote: true,
    is_hidden: false
  }
]

export const tempForumComments: ForumComment[] = [
  {
    id_slug: 'comment-0',
    created_date: '2024-12-08T13:19:53.648Z',
    modified_date: '2024-12-08T13:19:53.648Z',
    author: tempForumUsers[0],
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco',
    is_answer: false,
    vote_value: 1,
    reply_count: 0,
    upvote_count: 21,
    downvote_count: 10,
    total_vote_count: 11,
    is_user_downvote: false,
    is_user_upvote: true,
    is_hidden: false,
    post: dummyPost,
    replies: [tempForumReplies[0], tempForumReplies[1], tempForumReplies[5], tempForumReplies[2]]
  },
  {
    id_slug: 'comment-1',
    created_date: '2024-12-09T13:19:53.648Z',
    modified_date: '2024-12-09T13:19:53.648Z',
    author: tempForumUsers[1],
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco',
    is_answer: false,
    vote_value: -1,
    reply_count: 0,
    upvote_count: 21,
    downvote_count: 10,
    total_vote_count: 11,
    is_user_downvote: true,
    is_user_upvote: false,
    is_hidden: false,
    post: dummyPost
  },
  {
    id_slug: 'comment-2',
    created_date: '2024-12-05T13:19:53.648Z',
    modified_date: '2024-12-05T13:19:53.648Z',
    author: tempForumUsers[2],
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco',
    is_answer: true,
    vote_value: 1,
    reply_count: 0,
    upvote_count: 21,
    downvote_count: 10,
    total_vote_count: 11,
    is_user_downvote: false,
    is_user_upvote: true,
    is_hidden: false,
    post: dummyPost,
    replies: [tempForumReplies[2], tempForumReplies[3], tempForumReplies[4]]
  },
  {
    id_slug: 'comment-3',
    created_date: '2024-12-05T13:19:53.648Z',
    modified_date: '2024-12-05T13:19:53.648Z',
    author: tempForumUsers[2],
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco',
    is_answer: true,
    vote_value: 1,
    reply_count: 0,
    upvote_count: 21,
    downvote_count: 10,
    total_vote_count: 11,
    is_user_downvote: false,
    is_user_upvote: true,
    is_hidden: false,
    post: dummyPost,
    replies: [tempForumReplies[2], tempForumReplies[3], tempForumReplies[4]]
  },
  {
    id_slug: 'comment-4',
    created_date: '2024-12-05T13:19:53.648Z',
    modified_date: '2024-12-05T13:19:53.648Z',
    author: tempForumUsers[2],
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco',
    is_answer: true,
    vote_value: 1,
    reply_count: 0,
    upvote_count: 21,
    downvote_count: 10,
    total_vote_count: 11,
    is_user_downvote: false,
    is_user_upvote: true,
    is_hidden: false,
    post: dummyPost,
    replies: [tempForumReplies[2], tempForumReplies[3], tempForumReplies[4]]
  },
  {
    id_slug: 'comment-5',
    created_date: '2024-12-05T13:19:53.648Z',
    modified_date: '2024-12-05T13:19:53.648Z',
    author: tempForumUsers[2],
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco',
    is_answer: true,
    vote_value: 1,
    reply_count: 0,
    upvote_count: 21,
    downvote_count: 10,
    total_vote_count: 11,
    is_user_downvote: false,
    is_user_upvote: true,
    is_hidden: false,
    post: dummyPost,
    replies: [tempForumReplies[2], tempForumReplies[3], tempForumReplies[4]]
  },
  {
    id_slug: 'comment-6',
    created_date: '2024-12-05T13:19:53.648Z',
    modified_date: '2024-12-05T13:19:53.648Z',
    author: tempForumUsers[2],
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco',
    is_answer: true,
    vote_value: 1,
    reply_count: 0,
    upvote_count: 21,
    downvote_count: 10,
    total_vote_count: 11,
    is_user_downvote: false,
    is_user_upvote: true,
    is_hidden: false,
    post: dummyPost,
    replies: [tempForumReplies[2], tempForumReplies[3], tempForumReplies[4]]
  },
  {
    id_slug: 'comment-7',
    created_date: '2024-12-05T13:19:53.648Z',
    modified_date: '2024-12-05T13:19:53.648Z',
    author: tempForumUsers[2],
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco',
    is_answer: true,
    vote_value: 1,
    reply_count: 0,
    upvote_count: 21,
    downvote_count: 10,
    total_vote_count: 11,
    is_user_downvote: false,
    is_user_upvote: true,
    is_hidden: false,
    post: dummyPost,
    replies: [tempForumReplies[2], tempForumReplies[3], tempForumReplies[4]]
  }
]

export const tempForumPost: ForumPost[] = [
  {
    id_slug: 'post-0',
    tags: [tempForumTags[0], tempForumTags[10]],
    author: tempForumUsers[0],
    title: 'Why is JavaScript asynchronous by default?',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    created_date: '2024-12-01T13:19:53.648Z',
    modified_date: '2024-12-01T13:19:53.648Z',
    groups: [],
    vote_value: 1,
    answer_count: 0,
    comment_count: 0,
    upvote_count: 10,
    downvote_count: 2,
    total_vote_count: 8,
    is_hidden: false,
    is_announcement: false,
    is_pinned: true,
    is_user_downvote: false,
    is_user_follow: false,
    is_user_upvote: true,
    is_bookmarked: true,
    is_resolved: false,
    comments: [tempForumComments[0], tempForumComments[1], tempForumComments[2]],
    categories: [tempForumCategory[0], tempForumCategory[1]],
    image: '/images/landing/landing-page/img-4.png'
  },
  {
    id_slug: 'post-1',
    tags: [tempForumTags[11], tempForumTags[15]],
    author: tempForumUsers[1],
    title: `Thoughts on React's Popularity`,
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    created_date: '2024-12-01T13:19:53.648Z',
    modified_date: '2024-12-01T13:19:53.648Z',
    groups: [],
    vote_value: 0,
    answer_count: 0,
    comment_count: 0,
    upvote_count: 10,
    downvote_count: 2,
    total_vote_count: 8,
    is_hidden: false,
    is_announcement: false,
    is_pinned: true,
    is_user_downvote: false,
    is_user_follow: true,
    is_user_upvote: false,
    is_resolved: false,
    is_bookmarked: false,
    comments: [tempForumComments[0], tempForumComments[1], tempForumComments[2]],
    categories: [tempForumCategory[1], tempForumCategory[2]]
  },
  {
    id_slug: 'post-2',
    tags: [tempForumTags[1], tempForumTags[12]],
    author: tempForumUsers[2],
    title: `Best practices for database schema design?`,
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    created_date: '2024-12-01T13:19:53.648Z',
    modified_date: '2024-12-01T13:19:53.648Z',
    groups: [],
    vote_value: -1,
    answer_count: 0,
    comment_count: 0,
    upvote_count: 10,
    downvote_count: 2,
    total_vote_count: 8,
    is_hidden: false,
    is_announcement: false,
    is_pinned: true,
    is_user_downvote: true,
    is_user_follow: false,
    is_user_upvote: false,
    is_resolved: false,
    is_bookmarked: false,
    comments: [tempForumComments[0], tempForumComments[1], tempForumComments[2]],
    categories: [tempForumCategory[0], tempForumCategory[2]]
  },
  {
    id_slug: 'post-3',
    tags: [tempForumTags[7], tempForumTags[8]],
    author: tempForumUsers[3],
    title: `Which programming language is best for beginners?`,
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    created_date: '2024-12-01T13:19:53.648Z',
    modified_date: '2024-12-01T13:19:53.648Z',
    groups: [],
    vote_value: 0,
    answer_count: 0,
    comment_count: 0,
    upvote_count: 10,
    downvote_count: 2,
    total_vote_count: 8,
    is_hidden: false,
    is_announcement: false,
    is_pinned: false,
    is_user_downvote: false,
    is_user_follow: false,
    is_user_upvote: false,
    is_resolved: false,
    is_bookmarked: false,
    comments: [tempForumComments[0], tempForumComments[1], tempForumComments[2]],
    categories: [tempForumCategory[1], tempForumCategory[1]]
  },
  {
    id_slug: 'post-4',
    tags: [tempForumTags[10], tempForumTags[12]],
    author: tempForumUsers[4],
    title: `How to choose the right tech stack?`,
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    created_date: '2024-12-01T13:19:53.648Z',
    modified_date: '2024-12-01T13:19:53.648Z',
    groups: [],
    vote_value: 1,
    answer_count: 0,
    comment_count: 0,
    upvote_count: 10,
    downvote_count: 2,
    total_vote_count: 8,
    is_hidden: false,
    is_announcement: false,
    is_pinned: false,
    is_user_downvote: false,
    is_user_follow: false,
    is_user_upvote: true,
    is_resolved: true,
    is_bookmarked: false,
    comments: [tempForumComments[0], tempForumComments[1], tempForumComments[2]],
    categories: [tempForumCategory[1], tempForumCategory[2]]
  },
  {
    id_slug: 'post-5',
    tags: [tempForumTags[1], tempForumTags[14]],
    author: tempForumUsers[3],
    title: `Is AI replacing software developers?`,
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    created_date: '2024-12-01T13:19:53.648Z',
    modified_date: '2024-12-01T13:19:53.648Z',
    groups: [],
    vote_value: -1,
    answer_count: 0,
    comment_count: 0,
    upvote_count: 10,
    downvote_count: 2,
    total_vote_count: 8,
    is_hidden: false,
    is_announcement: false,
    is_pinned: true,
    is_user_downvote: true,
    is_user_follow: true,
    is_user_upvote: false,
    is_resolved: true,
    is_bookmarked: false,
    comments: [tempForumComments[0], tempForumComments[1], tempForumComments[2]],
    categories: [tempForumCategory[0], tempForumCategory[2]]
  },
  {
    id_slug: 'post-6',
    tags: [tempForumTags[0], tempForumTags[7]],
    author: tempForumUsers[2],
    title: `Best practices for securing personal data online?`,
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    created_date: '2024-12-01T13:19:53.648Z',
    modified_date: '2024-12-01T13:19:53.648Z',
    groups: [],
    vote_value: 0,
    answer_count: 0,
    comment_count: 0,
    upvote_count: 10,
    downvote_count: 2,
    total_vote_count: 8,
    is_hidden: false,
    is_announcement: false,
    is_pinned: false,
    is_user_downvote: false,
    is_user_follow: false,
    is_user_upvote: false,
    is_resolved: true,
    is_bookmarked: false,
    comments: [tempForumComments[0], tempForumComments[1], tempForumComments[2]],
    categories: [tempForumCategory[0], tempForumCategory[1]]
  },
  {
    id_slug: 'post-7',
    tags: [tempForumTags[12], tempForumTags[2]],
    author: tempForumUsers[1],
    title: `What's new in web development for 2024? this is a veeeeeeeeeeeeeeeeeeeeeeery very very long title though. It is weird but maybe if it is too long then how? it won't look good right?`,
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    created_date: '2024-12-01T13:19:53.648Z',
    modified_date: '2024-12-01T13:19:53.648Z',
    groups: [],
    vote_value: -1,
    answer_count: 0,
    comment_count: 0,
    upvote_count: 10,
    downvote_count: 2,
    total_vote_count: 8,
    is_hidden: false,
    is_announcement: false,
    is_pinned: false,
    is_user_downvote: true,
    is_user_follow: true,
    is_user_upvote: false,
    is_resolved: true,
    is_bookmarked: false,
    comments: [tempForumComments[0], tempForumComments[1], tempForumComments[2]],
    categories: [tempForumCategory[1], tempForumCategory[2]]
  },
  {
    id_slug: 'post-8',
    tags: [tempForumTags[18]],
    author: tempForumUsers[0],
    title: `Hi everyone. This is a class post.`,
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    created_date: '2024-12-01T13:19:53.648Z',
    groups: [],
    vote_value: -1,
    answer_count: 0,
    comment_count: 0,
    modified_date: '2024-12-01T13:19:53.648Z',
    upvote_count: 10,
    downvote_count: 2,
    total_vote_count: 8,
    is_hidden: false,
    is_announcement: false,
    is_pinned: false,
    is_user_downvote: true,
    is_user_follow: true,
    is_user_upvote: false,
    is_resolved: false,
    is_bookmarked: false,
    comments: [tempForumComments[0], tempForumComments[1], tempForumComments[2]],
    categories: [tempForumCategory[3]]
  },
  {
    id_slug: 'post-9',
    tags: [tempForumTags[19]],
    author: tempForumUsers[1],
    title: `Hi everyone. This is another class post.`,
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    created_date: '2024-12-01T13:19:53.648Z',
    groups: [],
    vote_value: -1,
    answer_count: 0,
    comment_count: 0,
    modified_date: '2024-12-01T13:19:53.648Z',
    upvote_count: 10,
    downvote_count: 2,
    total_vote_count: 8,
    is_hidden: false,
    is_announcement: false,
    is_pinned: false,
    is_user_downvote: true,
    is_user_follow: true,
    is_user_upvote: false,
    is_resolved: true,
    is_bookmarked: false,
    comments: [tempForumComments[0], tempForumComments[1], tempForumComments[2]],
    categories: [tempForumCategory[3]]
  },
  {
    id_slug: 'post-9-1',
    tags: [tempForumTags[20]],
    author: tempForumUsers[2],
    title: `Yep. This is another class post.`,
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    created_date: '2024-12-01T13:19:53.648Z',
    groups: [],
    vote_value: -1,
    answer_count: 0,
    comment_count: 0,
    modified_date: '2024-12-01T13:19:53.648Z',
    upvote_count: 10,
    downvote_count: 2,
    total_vote_count: 8,
    is_hidden: false,
    is_announcement: false,
    is_pinned: true,
    is_user_downvote: true,
    is_user_follow: false,
    is_user_upvote: false,
    is_resolved: true,
    is_bookmarked: false,
    comments: [tempForumComments[0], tempForumComments[1], tempForumComments[2]],
    categories: [tempForumCategory[3]]
  },
  {
    id_slug: 'post-9-2',
    tags: [tempForumTags[20]],
    author: tempForumUsers[4],
    title: `You guessed it. This is another class post.`,
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    created_date: '2024-12-01T13:19:53.648Z',
    modified_date: '2024-12-01T13:19:53.648Z',
    groups: [],
    vote_value: -1,
    answer_count: 0,
    comment_count: 0,
    upvote_count: 10,
    downvote_count: 2,
    total_vote_count: 8,
    is_hidden: false,
    is_announcement: false,
    is_pinned: true,
    is_user_downvote: true,
    is_user_follow: true,
    is_user_upvote: false,
    is_resolved: false,
    is_bookmarked: false,
    comments: [tempForumComments[0], tempForumComments[1], tempForumComments[2]],
    categories: [tempForumCategory[3]]
  },
  {
    id_slug: 'post-9-3',
    tags: [tempForumTags[20]],
    author: tempForumUsers[0],
    title: `You guessed it. This is another class post.`,
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    created_date: '2024-12-01T13:19:53.648Z',
    modified_date: '2024-12-01T13:19:53.648Z',
    groups: [],
    vote_value: -1,
    answer_count: 0,
    comment_count: 0,
    upvote_count: 10,
    downvote_count: 2,
    total_vote_count: 8,
    is_hidden: false,
    is_announcement: false,
    is_pinned: true,
    is_user_downvote: true,
    is_user_follow: false,
    is_user_upvote: false,
    is_resolved: false,
    is_bookmarked: false,
    comments: [tempForumComments[0], tempForumComments[1], tempForumComments[2]],
    categories: [tempForumCategory[3]]
  },
  {
    id_slug: 'post-9-4',
    tags: [tempForumTags[20]],
    author: tempForumUsers[2],
    title: `You guessed it. This is another class post.`,
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    created_date: '2024-12-01T13:19:53.648Z',
    modified_date: '2024-12-01T13:19:53.648Z',
    groups: [],
    vote_value: -1,
    answer_count: 0,
    comment_count: 0,
    upvote_count: 10,
    downvote_count: 2,
    total_vote_count: 8,
    is_hidden: false,
    is_announcement: false,
    is_pinned: true,
    is_user_downvote: true,
    is_user_follow: true,
    is_user_upvote: false,
    is_resolved: false,
    is_bookmarked: false,
    comments: [tempForumComments[0], tempForumComments[1], tempForumComments[2]],
    categories: [tempForumCategory[3]]
  },
  {
    id_slug: 'post-9-5',
    tags: [tempForumTags[20]],
    author: tempForumUsers[3],
    title: `You guessed it. This is another class post.`,
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    created_date: '2024-12-01T13:19:53.648Z',
    modified_date: '2024-12-01T13:19:53.648Z',
    groups: [],
    vote_value: -1,
    answer_count: 0,
    comment_count: 0,
    upvote_count: 10,
    downvote_count: 2,
    total_vote_count: 8,
    is_hidden: false,
    is_announcement: false,
    is_pinned: true,
    is_user_downvote: true,
    is_user_follow: true,
    is_user_upvote: false,
    is_resolved: false,
    is_bookmarked: false,
    comments: [tempForumComments[0], tempForumComments[1], tempForumComments[2]],
    categories: [tempForumCategory[3]]
  },
  {
    id_slug: 'post-9-7',
    tags: [tempForumTags[20]],
    author: tempForumUsers[1],
    title: `You guessed it. This is another class post.`,
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    created_date: '2024-12-01T13:19:53.648Z',
    modified_date: '2024-12-01T13:19:53.648Z',
    groups: [],
    vote_value: -1,
    answer_count: 0,
    comment_count: 0,
    upvote_count: 10,
    downvote_count: 2,
    total_vote_count: 8,
    is_hidden: false,
    is_announcement: false,
    is_pinned: true,
    is_user_downvote: true,
    is_user_follow: true,
    is_user_upvote: false,
    is_resolved: false,
    is_bookmarked: false,
    comments: [tempForumComments[0], tempForumComments[1], tempForumComments[2]],
    categories: [tempForumCategory[3]]
  },
  {
    id_slug: 'post-9-8',
    tags: [tempForumTags[20]],
    author: tempForumUsers[2],
    title: `You guessed it. This is another class post.`,
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    created_date: '2024-12-01T13:19:53.648Z',
    modified_date: '2024-12-01T13:19:53.648Z',
    groups: [],
    vote_value: -1,
    answer_count: 0,
    comment_count: 0,
    upvote_count: 10,
    downvote_count: 2,
    total_vote_count: 8,
    is_hidden: false,
    is_announcement: false,
    is_pinned: true,
    is_user_downvote: true,
    is_user_follow: true,
    is_user_upvote: false,
    is_resolved: false,
    is_bookmarked: false,
    comments: [tempForumComments[0], tempForumComments[1], tempForumComments[2]],
    categories: [tempForumCategory[3]]
  },
  {
    id_slug: 'post-9-9',
    tags: [tempForumTags[20]],
    author: tempForumUsers[3],
    title: `You guessed it. This is another class post.`,
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    created_date: '2024-12-01T13:19:53.648Z',
    modified_date: '2024-12-01T13:19:53.648Z',
    groups: [],
    vote_value: -1,
    answer_count: 0,
    comment_count: 0,
    upvote_count: 10,
    downvote_count: 2,
    total_vote_count: 8,
    is_hidden: false,
    is_announcement: false,
    is_pinned: true,
    is_user_downvote: true,
    is_user_follow: true,
    is_user_upvote: false,
    is_resolved: false,
    is_bookmarked: false,
    comments: [tempForumComments[0], tempForumComments[1], tempForumComments[2]],
    categories: [tempForumCategory[3]]
  },
  {
    id_slug: 'post-9-10',
    tags: [tempForumTags[20]],
    author: tempForumUsers[4],
    title: `You guessed it. This is another class post.`,
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    created_date: '2024-12-01T13:19:53.648Z',
    modified_date: '2024-12-01T13:19:53.648Z',
    groups: [],
    vote_value: -1,
    answer_count: 0,
    comment_count: 0,
    upvote_count: 10,
    downvote_count: 2,
    total_vote_count: 8,
    is_hidden: false,
    is_announcement: false,
    is_pinned: true,
    is_user_downvote: true,
    is_user_follow: true,
    is_user_upvote: false,
    is_resolved: false,
    is_bookmarked: false,
    comments: [tempForumComments[0], tempForumComments[1], tempForumComments[2]],
    categories: [tempForumCategory[3]]
  }
]

export const tempForumAnnouncements: ForumPost[] = [
  {
    id_slug: 'announcement-0',
    tags: [tempForumTags[20]],
    author: tempForumUsers[0],
    title: `Merry Christmas, everyone!`,
    description: '',
    created_date: '2024-12-01T13:19:53.648Z',
    modified_date: '2024-12-01T13:19:53.648Z',
    groups: [],
    vote_value: 0,
    answer_count: 0,
    comment_count: 0,
    upvote_count: 0,
    downvote_count: 0,
    total_vote_count: 0,
    is_hidden: false,
    is_announcement: true,
    is_pinned: false,
    is_resolved: false,
    categories: [tempForumCategory[3]]
  },
  {
    id_slug: 'announcement-1',
    tags: [tempForumTags[19]],
    author: tempForumUsers[0],
    title: `Today's tutorial is cancelled.`,
    description: '',
    created_date: '2024-12-01T13:19:53.648Z',
    modified_date: '2024-12-01T13:19:53.648Z',
    groups: [],
    vote_value: 0,
    answer_count: 0,
    comment_count: 0,
    upvote_count: 0,
    downvote_count: 0,
    total_vote_count: 0,
    is_hidden: false,
    is_announcement: true,
    is_pinned: false,
    is_resolved: false,
    categories: [tempForumCategory[3]]
  },
  {
    id_slug: 'announcement-2',
    tags: [tempForumTags[20]],
    author: tempForumUsers[0],
    title: `Today's live class will be postponed to next Monday. Please read up on Lab Assignment 3.`,
    description: '',
    created_date: '2024-12-01T13:19:53.648Z',
    modified_date: '2024-12-01T13:19:53.648Z',
    groups: [],
    vote_value: 0,
    answer_count: 0,
    comment_count: 0,
    upvote_count: 0,
    downvote_count: 0,
    total_vote_count: 0,
    is_hidden: false,
    is_announcement: true,
    is_pinned: false,
    is_resolved: false,
    categories: [tempForumCategory[3]]
  },
  {
    id_slug: 'announcement-3',
    tags: [tempForumTags[20]],
    author: tempForumUsers[0],
    title: `Welcome to the class, everyone!`,
    description: '',
    created_date: '2024-12-01T13:19:53.648Z',
    modified_date: '2024-12-01T13:19:53.648Z',
    groups: [],
    vote_value: 0,
    answer_count: 0,
    comment_count: 0,
    upvote_count: 0,
    downvote_count: 0,
    total_vote_count: 0,
    is_hidden: false,
    is_announcement: true,
    is_pinned: false,
    is_resolved: false,
    categories: [tempForumCategory[3]]
  },
  {
    id_slug: 'announcement-4',
    tags: [tempForumTags[20]],
    author: tempForumUsers[0],
    title: `Merry Christmas, everyone!`,
    description: '',
    created_date: '2024-12-01T13:19:53.648Z',
    modified_date: '2024-12-01T13:19:53.648Z',
    groups: [],
    vote_value: 0,
    answer_count: 0,
    comment_count: 0,
    upvote_count: 0,
    downvote_count: 0,
    total_vote_count: 0,
    is_hidden: false,
    is_announcement: true,
    is_pinned: false,
    is_resolved: false,
    categories: [tempForumCategory[3]]
  },
  {
    id_slug: 'announcement-5',
    tags: [tempForumTags[19]],
    author: tempForumUsers[0],
    title: `Today's tutorial is cancelled.`,
    description: '',
    created_date: '2024-12-01T13:19:53.648Z',
    modified_date: '2024-12-01T13:19:53.648Z',
    groups: [],
    vote_value: 0,
    answer_count: 0,
    comment_count: 0,
    upvote_count: 0,
    downvote_count: 0,
    total_vote_count: 0,
    is_hidden: false,
    is_announcement: true,
    is_pinned: false,
    is_resolved: false,
    categories: [tempForumCategory[3]]
  },
  {
    id_slug: 'announcement-6',
    tags: [tempForumTags[20]],
    author: tempForumUsers[0],
    title: `Today's live class will be postponed to next Monday. Please read up on Lab Assignment 3.`,
    description: '',
    created_date: '2024-12-01T13:19:53.648Z',
    modified_date: '2024-12-01T13:19:53.648Z',
    groups: [],
    vote_value: 0,
    answer_count: 0,
    comment_count: 0,
    upvote_count: 0,
    downvote_count: 0,
    total_vote_count: 0,
    is_hidden: false,
    is_announcement: true,
    is_pinned: false,
    is_resolved: false,
    categories: [tempForumCategory[3]]
  },
  {
    id_slug: 'announcement-7',
    tags: [tempForumTags[20]],
    author: tempForumUsers[0],
    title: `Welcome to the class, everyone! Please make yourself at home.`,
    description: '',
    created_date: '2024-12-01T13:19:53.648Z',
    modified_date: '2024-12-01T13:19:53.648Z',
    groups: [],
    vote_value: 0,
    answer_count: 0,
    comment_count: 0,
    upvote_count: 0,
    downvote_count: 0,
    total_vote_count: 0,
    is_hidden: false,
    is_announcement: true,
    is_pinned: false,
    is_resolved: false,
    categories: [tempForumCategory[3]]
  },
  {
    id_slug: 'announcement-8',
    tags: [tempForumTags[20]],
    author: tempForumUsers[0],
    title: `Today's live class will be postponed to next Monday. Please read up on Lab Assignment 3 and don't forget to load up your project during the tutorial.`,
    description: '',
    created_date: '2024-12-01T13:19:53.648Z',
    modified_date: '2024-12-01T13:19:53.648Z',
    groups: [],
    vote_value: 0,
    answer_count: 0,
    comment_count: 0,
    upvote_count: 0,
    downvote_count: 0,
    total_vote_count: 0,
    is_hidden: false,
    is_announcement: true,
    is_pinned: false,
    is_resolved: false,
    categories: [tempForumCategory[3]]
  },
  {
    id_slug: 'announcement-9',
    tags: [tempForumTags[20]],
    author: tempForumUsers[0],
    title: `Welcome to the class, everyone!`,
    description: '',
    created_date: '2024-12-01T13:19:53.648Z',
    modified_date: '2024-12-01T13:19:53.648Z',
    groups: [],
    vote_value: 0,
    answer_count: 0,
    comment_count: 0,
    upvote_count: 0,
    downvote_count: 0,
    total_vote_count: 0,
    is_hidden: false,
    is_announcement: true,
    is_pinned: false,
    is_resolved: false,
    categories: [tempForumCategory[3]]
  }
]

export const tempForumReports: ForumReport[] = [
  {
    id_slug: 'report-0',
    created_date: '2024-12-01T13:19:53.648Z',
    status: 'pending',
    reason: 'This is a random reason',
    post: tempForumPost[0],
    author: tempForumUsers[5]
  },
  {
    id_slug: 'report-1',
    created_date: '2024-12-01T13:19:53.648Z',
    status: 'pending',
    reason: 'This is a random reason',
    post: tempForumPost[2],
    author: tempForumUsers[2]
  },
  {
    id_slug: 'report-2',
    created_date: '2024-12-01T13:19:53.648Z',
    status: 'pending',
    reason: 'This is a random reason',
    comment: tempForumComments[0],
    author: tempForumUsers[1]
  },
  {
    id_slug: 'report-3',
    created_date: '2024-12-01T13:19:53.648Z',
    status: 'pending',
    reason: 'This is a random reason',
    comment: tempForumComments[0],
    author: tempForumUsers[3]
  },
  {
    id_slug: 'report-4',
    created_date: '2024-12-01T13:19:53.648Z',
    status: 'approved',
    reason: 'This is a random reason',
    post: tempForumPost[0],
    author: tempForumUsers[5]
  },
  {
    id_slug: 'report-5',
    created_date: '2024-12-01T13:19:53.648Z',
    status: 'approved',
    reason: 'This is a random reason',
    post: tempForumPost[2],
    author: tempForumUsers[2]
  },
  {
    id_slug: 'report-6',
    created_date: '2024-12-01T13:19:53.648Z',
    status: 'approved',
    reason: 'This is a random reason',
    comment: tempForumComments[0],
    author: tempForumUsers[4]
  },
  {
    id_slug: 'report-7',
    created_date: '2024-12-01T13:19:53.648Z',
    status: 'approved',
    reason: 'This is a random reason',
    comment: tempForumComments[0],
    author: tempForumUsers[1]
  }
]
